import { LicenseList } from './components'

export const CRBPanelContent = () => <LicenseList />
